import React from 'react';
import { useFormContext } from 'react-hook-form/dist/index.ie11';
import { CookbookSegmentedControlWrapper } from 'src/components/CookbookSegmentedControlWrapper/CookbookSegmentedControlWrapper';
import {
  creditTypeOptions,
  CreditTypeValues,
} from 'src/components/oneCorp/features/MealCredit/common/formFields/mealCreditFormFields.utils';

export interface CreditTypeSegmentedControlProps {
  name: string;
  id: string;
  disabled?: boolean;
}

export function CreditTypeSegmentedControl({
  name,
  id,
  disabled,
}: CreditTypeSegmentedControlProps): JSX.Element {
  const { control } = useFormContext();

  return (
    <CookbookSegmentedControlWrapper
      id={id}
      width="100%"
      control={control}
      disabled={disabled}
      label="Credit type"
      name={name}
      defaultValue={CreditTypeValues.SINGLE}
      options={creditTypeOptions}
    />
  );
}
